import Step5View from "components/view/signup/step5";

const Step5Page = () => {
  return <Step5View />;
};

export default Step5Page;
